'use client';
import React from 'react';
import { useRouter } from 'next/navigation';

export const extractUniqueTags = (messages) => {
	if (!Array.isArray(messages)) return [];
	const set = new Set();
	for (const m of messages) {
		const tags = Array.isArray(m?.tags) ? m.tags : [];
		for (const t of tags) {
			if (t) set.add(t);
		}
	}
	return Array.from(set).sort();
};

export const filterByTag = (messages, tag) => {
	if (!tag) return messages;
	if (!Array.isArray(messages)) return [];
	return messages.filter((m) => Array.isArray(m?.tags) && m.tags.includes(tag));
};

const sortTags = (tags, order) => {
	if (!order) return tags;
	return [...tags].sort((a, b) => {
		const aIndex = order.indexOf(a);
		const bIndex = order.indexOf(b);
		if (aIndex === -1 && bIndex === -1) return a.localeCompare(b);
		if (aIndex === -1) return 1;
		if (bIndex === -1) return -1;
		return aIndex - bIndex;
	});
};

const TagFilter = ({
	tags,
	selected,
	onSelect,
	labels = {},
	order,
	isPro,
	className = '',
}) => {
	const router = useRouter();

	if (!tags || tags.length === 0) return null;

	const chipClass = (active) =>
		`rounded-[10px] border border-[#B1ABAB] px-3 py-1 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#AF52DE] focus-visible:ring-offset-2 ${
			active
				? 'bg-[#AF52DE] text-white'
				: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
		}`;

	const sortedTags = sortTags(tags, order);

	const handleTagClick = (tag) => {
		if (!isPro) {
			router.push('/pro');
			return;
		}
		onSelect(tag);
	};

	return (
		<div
			role='group'
			aria-label='Filter messages by tag'
			className={`flex flex-wrap gap-2 ${className}`}
		>
			<button
				type='button'
				onClick={() => onSelect('')}
				aria-pressed={!selected}
				className={chipClass(!selected)}
			>
				All
			</button>
			{sortedTags.map((tag) => (
				<button
					key={tag}
					type='button'
					onClick={() => handleTagClick(tag)}
					aria-pressed={selected === tag}
					className={chipClass(selected === tag)}
				>
					{labels[tag] || `#${tag}`}
				</button>
			))}
		</div>
	);
};

export default TagFilter;
